(() => {
  const feedbackTimers = new WeakMap();
  const labels = () => window.KROWN.settings.locales;

  const showFeedback = button => {
    if (!button) return;
    const text = button.querySelector('[data-js-product-add-to-cart-text], .button__text') || button;
    const previous = feedbackTimers.get(button);
    if (previous) clearTimeout(previous.timer);
    const original = previous?.original || text.textContent;
    const added = labels().products_added_to_cart_button;
    text.textContent = added;
    button.classList.add('is-added');
    const timer = setTimeout(() => {
      if (text.textContent === added) text.textContent = original;
      button.classList.remove('is-added');
      feedbackTimers.delete(button);
    }, 3000);
    feedbackTimers.set(button, { original, timer });
  };

  const feedback = button => {
    if (!button) return;
    showFeedback(button);
    const productPage = button.closest('product-page');
    if (!productPage?.id || button.closest('.product-item__quick-buy')) return;
    document.querySelectorAll('sticky-add-to-cart[data-single]').forEach(bar => {
      if (bar.dataset.id === productPage.id) {
        showFeedback(bar.querySelector('[data-js-atc]'));
      }
    });
  };

  const error = (container, message) => {
    container.querySelector('[data-lumino-cart-error]')?.remove();
    const notice = document.createElement('p');
    notice.dataset.luminoCartError = '';
    notice.className = 'alert alert--error text-size--small';
    notice.setAttribute('role', 'alert');
    notice.textContent = message;
    container.append(notice);
  };

  window.LuminoCartActions = { feedback, error };

  const cache = new Map();
  const rootSelector = '#snize_results, #snize-instant-search-results';
  const cardSelector = '#snize_results li.snize-product, #snize-instant-search-results li.snize-product';

  const renderAction = async card => {
    const link = [...card.querySelectorAll('a[href]')].find(anchor => {
      const url = new URL(anchor.href, location.origin);
      return url.origin === location.origin && url.pathname.includes('/products/');
    });
    if (!link) return;
    const url = new URL(link.href, location.origin);
    const key = url.pathname;
    if (card.dataset.luminoCartCard === key) return;
    card.dataset.luminoCartCard = key;

    const wrapper = document.createElement('div');
    wrapper.className = 'lumino-search-product';
    const existing = [...card.childNodes];
    card.append(wrapper);
    wrapper.append(...existing);
    card.querySelectorAll('.snize-buttons').forEach(node => node.style.setProperty('display', 'none', 'important'));
    const holder = document.createElement('div');
    holder.className = 'lumino-search-cart product-item__quick-buy';
    holder.setAttribute('aria-busy', 'true');
    holder.addEventListener('click', event => event.stopPropagation());
    wrapper.append(holder);

    try {
      if (!cache.has(key)) {
        url.search = '';
        url.searchParams.set('section_id', 'lumino-search-cart-action');
        cache.set(key, fetch(url).then(response => {
          if (!response.ok) throw new Error('Product action unavailable');
          return response.text();
        }).catch(cause => { cache.delete(key); throw cause; }));
      }
      const html = await cache.get(key);
      if (!card.isConnected || card.dataset.luminoCartCard !== key) return;
      const action = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-lumino-search-cart-action]');
      if (!action?.querySelector('button, a')) throw new Error('Product action unavailable');
      holder.innerHTML = action.innerHTML;
    } catch {
      const fallback = document.createElement('a');
      fallback.className = 'button button--outline button--regular button--fullwidth';
      fallback.href = key;
      fallback.textContent = labels().products_view_button;
      holder.replaceChildren(fallback);
    } finally {
      holder.removeAttribute('aria-busy');
    }
  };

  const watched = new WeakSet();
  const intersection = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      intersection.unobserve(entry.target);
      renderAction(entry.target);
    });
  }, { rootMargin: '120px' });

  const scan = () => {
    document.querySelectorAll(cardSelector).forEach(card => {
      if (watched.has(card) && card.querySelector('.lumino-search-cart')) return;
      if (card.dataset.luminoCartCard && !card.querySelector('.lumino-search-cart')) delete card.dataset.luminoCartCard;
      watched.add(card);
      intersection.observe(card);
    });
  };

  let scheduled = false;
  new MutationObserver(mutations => {
    if (scheduled || !mutations.some(mutation => mutation.target instanceof Element && (mutation.target.closest(rootSelector) || [...mutation.addedNodes].some(node => node instanceof Element && (node.matches(rootSelector) || node.querySelector(rootSelector)))))) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true });
  scan();
})();
